
const init = () => {

    const elInput = document.querySelector('#search-field, input')
    const elForm = document.querySelector('#search')
    const elLiveWrapper = document.querySelector('.live-search__wrapper')
    const elLive = document.querySelector('.live-search__holder')
    const elClose = document.querySelector('#search-close')

    if (elInput && elClose) {

        let isSearch = false

        elClose.addEventListener('click', (e) => {
            elLiveWrapper.classList.add('hidden')
            elLive.innerHTML = ''
        })

        elInput.addEventListener('input', (e) => {
            const query = e.target.value
            if (!isSearch && query.length > 3) {
                isSearch = true
                axios({
                    method: 'get',
                    url: elForm.getAttribute('action') + '?live=' + query
                })
                .then( response => {
                    if (response.data.products.length > 0) {
                        elLive.innerHTML = response.data.html
                        elLiveWrapper.classList.remove('hidden')
                    } else {
                        elLiveWrapper.classList.add('hidden')
                        elLive.innerHTML = ''
                    }
                })
                .catch( error => {
                    console.log('error', error)
                })
                .finally(() => {
                    isSearch = false
                })
            } else if (!isSearch && query.length <= 3) {
                elLiveWrapper.classList.add('hidden')
                elLive.innerHTML = ''
            }
        })
    }

}

export default { init }
